<template>
    <aside  ref="sidebar" @click.prevent="toggleMenu"   class="sidebar sidebar--hidden" :class="{'toggled': toggled}">
        <initiative-button v-if="isTicketCreationAvailable" class="sidebar__add-button" icon="plus" @click="quickCreateClicked">
            {{$t("LBL_MAIN_BUTTON")}}
        </initiative-button>
        <div class="scrollbar-inner">
            <ul class="navigation sidebar__navigation">
                <li class="navigation__menuitem" v-for="menuItem in menuItems"
                    :class="{'navigation__active': linkSelected(menuItem)}">
                    <router-link :to="menuItem.link">
                        <div v-html="require('!html-loader!@/assets/icons/icn-' + menuItem.icon + '.svg')"></div>
                        <span>{{ menuItem.label }}</span>
                    </router-link>
                </li>
            </ul>
        </div>
    </aside>
</template>

<script>
    import InitiativeButton from "@/components/Button"

    export default {
        data() {
            return {
                toggled: true,
                headerEl: null
            }
        },

        props: {
            menuItems: {
                default: function () {
                    return []
                }
            },
            name: {default: 'menuSidebar'},
            selectedItem: String
        },

        computed: {
          isTicketCreationAvailable() {
            return this.$store.getters.getStructure.access && this.$store.getters.getStructure.access.client_portal
          }
        },

        components: {InitiativeButton},
        beforeDestroy () {
            if (this.isMobileScreen()) {
                document.removeEventListener('click',this.toggleMenu)
            }
        },

        beforeMount() {
            if(this.isMobileScreen()){
                this.toggled = false
            }
        },

        mounted() {
            if (this.isMobileScreen()) {
                document.addEventListener('click', this.toggleMenu)
            }
            this.headerEl=document.getElementById("headerButton")
            this.$eventBus.$on('toggleSlider', (data) => {
                if (this.name !== data.slider) {
                    return
                }

                if (data.status === 'open') {
                    this.toggled = true
                } else {
                    this.toggled = false
                }
            })
        },
        methods: {
            linkSelected(menuItem) {
                if (menuItem.name === this.selectedItem) {
                    return true
                } else {
                    return false
                }
            },
            toggleMenu(el) {
                if (this.$refs.sidebar && !this.$refs.sidebar.contains(el.target) && el.target !== this.$refs.sidebar) {
                    if (!this.headerEl.contains(el.target) && el.target !== this.headerEl && this.toggled) {
                        this.$eventBus.$emit('toggleSlider', {slider: this.name, status: this.toggled?'close':'open'})
                    }
                }
            },
            quickCreateClicked() {
                this.$emit('quickcreate-clicked')
            }
        },

    }
</script>
<style lang="scss">@import "@/assets/scss/components/_sidebar.scss";</style>